import axios from 'axios';
import store from "../store";

const PREFIJO="/api/DcmNgc/";

export default {
    crearDocumentos(formualrio) {
        const dto ={
            id:store.getters.getCotizacion.ndt5,
            //ndt1:store.getters.getCotizacion.ndt5, id de prospecto
            elements:formualrio,
        };
        return axios.post(`${PREFIJO}VmCrDcN`,dto);
    }
};
